import { Layout, Menu, Typography } from "antd";
import {
  UserOutlined,
  SettingOutlined,
  ScheduleOutlined,
  CloudUploadOutlined,
  CarOutlined,
  ToolOutlined,
  ExperimentOutlined,
  AuditOutlined,
  DashboardOutlined,
  ContainerOutlined,
  RobotOutlined,
  ThunderboltOutlined,
  ShopOutlined,
  IdcardOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Sider } = Layout;
const { Text } = Typography;

const menuItems = [
  {
    type: "group" as const,
    label: "Home",
    children: [
      {
        key: "/dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
      },
      {
        key: "/ai",
        icon: <RobotOutlined />,
        label: "AI Assistant",
      },
    ],
  },
  {
    type: "group" as const,
    label: "Yard Operations",
    children: [
      {
        key: "/",
        icon: <ExperimentOutlined />,
        label: "Weighbridge",
      },
      {
        key: "/live",
        icon: <ThunderboltOutlined />,
        label: "Live Operations",
      },
      {
        key: "/rakes",
        icon: <ContainerOutlined />,
        label: "Rakes",
      },
      {
        key: "/workflow",
        icon: <AuditOutlined />,
        label: "Workflow",
      },
    ],
  },
  {
    type: "group" as const,
    label: "Workforce",
    children: [
      {
        key: "/drivers",
        icon: <CarOutlined />,
        label: "Drivers",
      },
      {
        key: "/labours",
        icon: <ToolOutlined />,
        label: "Labours",
      },
      {
        key: "/warehouse-members",
        icon: <ShopOutlined />,
        label: "Warehouse Staff",
      },
      {
        key: "/members",
        icon: <UserOutlined />,
        label: "Members",
      },
    ],
  },
  {
    type: "group" as const,
    label: "Records",
    children: [
      {
        key: "/documents/clientwise",
        icon: <IdcardOutlined />,
        label: "Clientwise Docs",
      },
      {
        key: "/documents/vehiclewise",
        icon: <TeamOutlined />,
        label: "Vehiclewise Docs",
      },
      {
        key: "/upload",
        icon: <CloudUploadOutlined />,
        label: "Uploads",
      },
      {
        key: "/reminders",
        icon: <ScheduleOutlined />,
        label: "Reminders",
      },
    ],
  },
  {
    type: "group" as const,
    label: "System",
    children: [
      {
        key: "/settings",
        icon: <SettingOutlined />,
        label: "Settings",
      },
    ],
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const allItems = menuItems.flatMap((group) => group.children);
  const selectedKey =
    allItems.find(
      (item) => item.key !== "/" && location.pathname.startsWith(item.key)
    )?.key || (location.pathname === "/" ? "/" : "");

  return (
    <Sider
      width={210}
      theme="dark"
      style={{
        position: "fixed",
        left: 0,
        top: 64,
        height: "calc(100vh - 64px)",
        borderRight: "1px solid rgba(255,255,255,0.04)",
        display: "flex",
        flexDirection: "column",
        zIndex: 100,
      }}
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
        className="compact-sidenav"
        style={{ flex: 1, border: "none", paddingBottom: 16 }}
      />
      <style>{`
        .compact-sidenav .ant-menu-item,
        .compact-sidenav .ant-menu-submenu-title {
          height: 32px !important;
          line-height: 32px !important;
          margin: 2px 8px !important;
        }
        .compact-sidenav .ant-menu-item-group-title {
          padding: 8px 16px 4px !important;
          font-size: 11px !important;
          line-height: 1 !important;
        }
      `}</style>

      <div
        style={{
          padding: "14px 16px",
          borderTop: "1px solid rgba(255,255,255,0.06)",
          marginTop: "auto",
          textAlign: "center",
        }}
      >
        <Text
          style={{
            color: "#64748b",
            fontSize: 11,
            display: "block",
          }}
        >
          Access Warehousing v1.0
        </Text>
      </div>
    </Sider>
  );
};

export default Sidebar;
